import { useState, useEffect } from 'react';
import logo from '../assets/images/koreansir-logo.webp';
import './Navbar.css';

const MENU_ITEMS = [
  { path: '/', label: 'කොරියන් සර්' },
  { path: '/before-korea', label: 'කොරියාවට යාමට පෙර' },
  { path: '/language', label: 'භාෂා හුරුව' },
  { path: '/faq', label: 'ප්‍රශ්න හා පිළිතුරු' },
  { path: '/news', label: 'කොරියන් තතු' },
  { path: '/contact', label: 'අමතන්න' },
];

export default function Navbar({ currentPath = '/', onNavigate }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    let raf = 0;
    const handleScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const scrolled = window.scrollY > 50;
        setIsScrolled((prev) => (prev === scrolled ? prev : scrolled));
      });
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <nav className={`navbar-shell ${isScrolled ? 'is-scrolled' : ''}`} lang="si">
      <div className="navbar">
        <a
          href="/"
          className="navbar-logo"
          aria-label="කොරියන් සර්"
          onClick={(e) => {
            e.preventDefault();
            onNavigate?.('/');
            setIsMenuOpen(false);
          }}
        >
          <img src={logo} alt="" />
        </a>

        <ul className={`navbar-links ${isMenuOpen ? 'is-open' : ''}`}>
          {MENU_ITEMS.map((item) => {
            const isActive = currentPath === item.path;

            return (
              <li key={item.path}>
                <a
                  href={item.path}
                  className={isActive ? 'is-active' : undefined}
                  onClick={(e) => {
                    e.preventDefault();
                    onNavigate?.(item.path);
                    setIsMenuOpen(false);
                  }}
                >
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>

        <div className="navbar-actions">
          <a href="https://play.google.com/store/apps/details?id=com.aeonian.koreansirapp&hl=en" target="_blank" rel="noopener noreferrer" className="navbar-cta">
            <span className="cta-icon-wrapper">
              <svg className="download-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <g className="anim-arrow">
                  <line x1="12" y1="3" x2="12" y2="15" />
                  <polyline points="5 9 12 16 19 9" />
                </g>
                <path d="M5 20h14" />
              </svg>
            </span>
            Download Now
          </a>

          <button 
            className={`navbar-toggle ${isMenuOpen ? 'is-open' : ''}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </div>
    </nav>
  );
}
